import * as Factory from 'factory.ts'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  TutorialStatus,
  type TutorialStatusConstructor,
} from './TutorialStatus'

export const TutorialStatusConstructorFactory =
  Factory.Sync.makeFactory<TutorialStatusConstructor>({
    isPunchOutApprovalWarningSuppressed: false,
  })

export const TutorialStatusFactory = EntityFactory(
  TutorialStatus,
  TutorialStatusConstructorFactory
)
